import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import SharedBids from "components/sharedbids";
import { organizationDemoPeriodStatusesEnum } from "helpers/enums";
import { load, store } from "helpers/filtersStorage";
import { tableContainer } from "helpers/redux";
import { mergeFilters } from "helpers/reqparams";
import { isOnlyInRole } from "helpers/roles";
import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import Filter from "./filter";
import List from "./list";

export class BidsSortable extends BookIndex {
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.params.orderBy) {
            const { 0: orderValue } = nextProps.params.orderBy;
            const { 0: column, 1: value } = orderValue.split(" ");
            this.setState({ activeSort: { column, value } });
        }
    }

    sortData = (elements) => {
        const { mergeParams, params } = this.props;
        const filter = { name: "externalId", value: null };
        params.orderBy = elements.map(({ name, value }) => {
            if (name === "externalId") {
                filter.value = { ne: null };
            }
            return [name, value].join(" ");
        });
        mergeFilters(mergeParams, filter, params);
    };
}

class Bids extends BidsSortable {
    state = {
        items: [],
        filtersOpened: false,
        activeSort: {},
        showFullAddress: load("showBidsFullAddress", false),
        showFactDates: load("showFactDates", false),
    };

    renderCreateButton = () => {
        const { canCreateBids, organization } = this.props;
        const isDemoPeriodExpired = organization.demoPeriod?.status === organizationDemoPeriodStatusesEnum.Expired;

        if (!canCreateBids || organization.distributedBidRequired || isDemoPeriodExpired) {
            return null;
        }
        const { history, match, createBtnText, onlyRoot } = this.props;
        const {
            isRoot,
            isAdmin,
            isTruckingOrganizationAdmin,
            isTruckingOrganizationManager,
            isTruckingOrganizationOperator,
            isCargoOwnerAdmin,
            isCargoOwnerManager,
            isForwarder,
        } = this.props.roles;
        if (!isRoot && onlyRoot) {
            return null;
        }
        if (isForwarder) {
            return (
                <Fragment>
                    <span className="btn btn-sm mr-2">Создание заявки:</span>
                    <a className="btn btn-brand btn-sm mr-2" onClick={() => history.push(`${match.path}/new`)}>
                        Внутренняя
                    </a>
                    <a className="btn btn-brand btn-sm" onClick={() => history.push(`${match.path}/new?type=public`)}>
                        Внешняя
                    </a>
                </Fragment>
            );
        }
        if (
            !(
                isRoot ||
                isAdmin ||
                isTruckingOrganizationAdmin ||
                isTruckingOrganizationManager ||
                isTruckingOrganizationOperator ||
                isCargoOwnerAdmin ||
                isCargoOwnerManager
            )
        ) {
            return null;
        }
        const props = {
            className: "btn btn-brand btn-sm",
            onClick: () => history.push(`${match.path}/new`),
        };
        return createBtnText ? <div {...props}>{createBtnText}</div> : null;
    };

    toggleFullAddress = () => {
        store("showBidsFullAddress", !this.state.showFullAddress);
        this.setState({ showFullAddress: !this.state.showFullAddress });
    };

    toggleFactDates = () => {
        store("showFactDates", !this.state.showFactDates);
        this.setState({ showFactDates: !this.state.showFactDates });
    };

    toggleFilter = () => {
        this.setState({ filtersOpened: !this.state.filtersOpened });
    };

    renderHead = () => {
        return (
            <div className="book-list__head">
                <div className="book-list__head-close close close--sm" onClick={this.close} />
                <div className="book-list__head-title">
                    {this.props.title}
                    {this.renderCounter()}
                </div>
                <div className="btn-toolbar">{this.renderCreateButton()}</div>
            </div>
        );
    };

    render() {
        if (isOnlyInRole(this.props.roles, "isGuest")) {
            return <SharedBids isTable title="Список заявок" />;
        }
        const { listRoute, params, mergeParams, organizationTimezone, carId, roles, organization, profile, trailerId } =
            this.props;
        const { customFilters } = params;
        const { items, activeSort, showFullAddress, showFactDates, filtersOpened } = this.state;
        const listProps = {
            activeSort,
            showFullAddress,
            showFactDates,
            organizationTimezone,
            sortData: this.sortData,
            checkedItems: items,
            showAllPointAddresses: customFilters.showAllPointAddresses,
            showLogistColumn: customFilters.showLogistColumn,
            showOrganizationColumn: customFilters.showOrganizationColumn,
            showCostAwareValues: customFilters.showCostAwareValues,
        };

        const filterProps = {
            profile,
            params,
            mergeParams,
            showFullAddress,
            showFactDates,
            organizationTimezone,
            filtersOpened,
            carId,
            trailerId,
            roles,
            organization,
            enums: this.props.enums,
            filters: customFilters || {},
            toggleFullAddress: this.toggleFullAddress,
            toggleFactDates: this.toggleFactDates,
            toggleFilter: this.toggleFilter,
        };
        return (
            <Transition dir="full" {...listRoute}>
                <div className="page-book__list book-list list">
                    {this.renderHead()}
                    <div className="container-fluid mt-1 mb-3">
                        <Filter {...filterProps} />
                    </div>
                    <List {...this.props} {...listProps} />
                </div>
            </Transition>
        );
    }
}

export default withRouter(tableContainer(Bids, "bids"));
